module.exports = __webpack_public_path__ + "static/media/logo.5d5d9eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Dashboard/Logo/logo.svg
// module id = 416
// module chunks = 0